import React from "react";
import {
    Button,
    ConfigProvider,
    DatePicker,
    Input,
    InputNumber,
    Select,
} from "antd";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import "./filter-panel.css";

dayjs.locale("zh-cn");
const theme = {
    token: {
        colorPrimary: "#6157b9",
        borderRadius: 7,
        controlHeight: 38,
        fontSize: 12,
    },
};

// Ant Design is scoped to the controls. The matrix and cards remain custom components.
export default function FilterPanel({
                                        brands,
                                        countries,
                                        disabled,
                                        filters,
                                        changeFilter,
                                        resetFilters,
                                        hasFilters,
                                        ramOptions,
                                        groupOfRamRomOptions,
                                        storageOptions,
                                        networkOptions,
                                        launchError,
                                        draft,
                                        setDraft,
                                        applyRange,
                                        buckets,
                                        rangeError,
                                    }) {
    const options = (values, suffix = "") => [
        { value: "", label: "全部" },
        ...values.map((value) => ({
            value: value.id || String(value),
            label: value.name || `${value}${suffix}`,
        })),
    ];
    return (
        <ConfigProvider locale={zhCN} theme={theme}>
            <section
                className="control-panel antd-filter-panel"
                aria-label="矩阵筛选和价格设置"
            >
                <div className="filter-row">
                    <Input
                        className="antd-search"
                        aria-label="搜索商品"
                        placeholder="搜索商品名称"
                        allowClear
                        disabled={disabled}
                        value={filters.query}
                        onChange={(e) => changeFilter("query", e.target.value)}
                    />
                    <div className="antd-filter-field antd-brand-field">
                        <span>品牌</span>
                        <Select
                            disabled={disabled}
                            mode="multiple"
                            aria-label="品牌筛选"
                            className="antd-brand-select"
                            placeholder="选择品牌"
                            value={filters.brandIds}
                            maxTagCount={1}
                            maxTagPlaceholder={(omitted) => `+${omitted.length}`}
                            options={brands.map((b) => ({
                                value: b.id,
                                label: b.name,
                            }))}
                            onChange={(value) => changeFilter("brandIds", value)}
                            popupRender={(menu) => (
                                <>
                                    <div className="antd-brand-actions">
                                        <span>
                                          已选 {filters.brandIds.length}/{brands.length}
                                        </span>
                                        <Button
                                            type="link"
                                            size="small"
                                            onClick={() =>
                                                changeFilter(
                                                    "brandIds",
                                                    brands.map((b) => b.id),
                                                )
                                            }
                                        >
                                            全选
                                        </Button>
                                        <Button
                                            type="link"
                                            size="small"
                                            onClick={() => changeFilter("brandIds", [])}
                                        >
                                            取消全选
                                        </Button>
                                    </div>
                                    {menu}
                                </>
                            )}
                        />
                    </div>
                    <div className="antd-filter-field">
                        <span>存储</span>
                        <Select
                            showSearch
                            className="antd-ram-rom-select"
                            disabled={disabled}
                            aria-label="存储筛选"
                            value={filters.groupOfRamRom}
                            options={[
                                { value: "", label: "全部" },
                                ...groupOfRamRomOptions.map((item) => ({
                                    value: `${item.ram}_${item.rom}`,
                                    label: `${item.ram}+${item.rom}`,
                                }))
                            ]}
                            onChange={(value) => changeFilter("groupOfRamRom", value)}
                        />
                    </div>
                    {/*<div className="antd-filter-field">*/}
                    {/*    <span>内存</span>*/}
                    {/*    <Select*/}
                    {/*        disabled={disabled}*/}
                    {/*        aria-label="内存筛选"*/}
                    {/*        value={filters.ram}*/}
                    {/*        options={options(ramOptions, " GB")}*/}
                    {/*        onChange={(value) => changeFilter("ram", value)}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    {/*<div className="antd-filter-field">*/}
                    {/*    <span>存储</span>*/}
                    {/*    <Select*/}
                    {/*        disabled={disabled}*/}
                    {/*        aria-label="存储筛选"*/}
                    {/*        value={filters.storage}*/}
                    {/*        options={options(storageOptions, " GB")}*/}
                    {/*        onChange={(value) => changeFilter("storage", value)}*/}
                    {/*    />*/}
                    {/*</div>*/}
                    <div className="antd-filter-field">
                        <span>网络</span>
                        <Select
                            disabled={disabled}
                            aria-label="网络筛选"
                            value={filters.network}
                            options={options(networkOptions)}
                            onChange={(value) => changeFilter("network", value)}
                        />
                    </div>
                    <div className="antd-filter-field">
                        <span>国家</span>
                        <Select
                            disabled={disabled}
                            aria-label="国家筛选"
                            className="antd-country-select"
                            showSearch
                            optionFilterProp="label"
                            value={filters.countryId}
                            onChange={(value) => changeFilter("countryId", value)}
                            options={[
                                ...countries.map((country) => ({
                                    value: country.id,
                                    label: country.name,
                                })),
                            ]}
                        />
                    </div>
                    <div
                        className="launch-row launch-inline"
                        role="group"
                        aria-label="上市时间区间筛选"
                    >
                        <span className="setting-label">上市时间</span>
                        <label className="sr-only" htmlFor="launch-start">
                            上市开始日期
                        </label>
                        <label className="sr-only" htmlFor="launch-end">
                            上市结束日期
                        </label>
                        <DatePicker.RangePicker
                            disabled={disabled}
                            className="launch-range-picker"
                            id={{ start: "launch-start", end: "launch-end" }}
                            placeholder={["开始日期", "结束日期"]}
                            value={[
                                filters.launchStart ? dayjs(filters.launchStart) : null,
                                filters.launchEnd ? dayjs(filters.launchEnd) : null,
                            ]}
                            // picker="month"
                            format="YYYY-MM-DD"
                            allowEmpty={[true, true]}
                            status={launchError ? "error" : undefined}
                            aria-describedby={launchError ? "launch-error" : "launch-hint"}
                            onChange={(_, values) => {
                                changeFilter("launchStart", values?.[0] || "");
                                changeFilter("launchEnd", values?.[1] || "");
                            }}
                            // onChange={(dates) => {
                            //     changeFilter("launchStart", dates?.[0]?.startOf("month").format("YYYY-MM-DD") || "");
                            //     changeFilter("launchEnd", dates?.[1]?.endOf("month").format("YYYY-MM-DD") || "");
                            // }}
                        />
                        {launchError && (
                            <p className="launch-error" id="launch-error" role="alert">
                                {launchError}
                            </p>
                        )}
                    </div>
                    <Button
                        className="antd-reset"
                        disabled={disabled || !hasFilters}
                        onClick={resetFilters}
                    >
                        重置筛选
                    </Button>
                </div>
                {/*<div*/}
                {/*  className="filter-row secondary-filter-row"*/}
                {/*  role="group"*/}
                {/*  aria-label="硬件配置条件"*/}
                {/*>*/}
                {/*  */}
                {/*</div>*/}
                <div className="range-row">
                    <form onSubmit={applyRange} noValidate>
                        <span className="setting-label">价格区间</span>
                        <InputNumber
                            aria-label="最低价格"
                            // prefix="$"
                            stringMode
                            step="50"
                            value={draft.min || null}
                            onChange={(value) =>
                                setDraft((prev) => ({
                                    ...prev,
                                    min: value == null ? "" : String(value),
                                }))
                            }
                        />
                        <span className="range-dash">—</span>
                        <InputNumber
                            aria-label="最高价格"
                            // prefix="$"
                            stringMode
                            step="50"
                            value={draft.max || null}
                            onChange={(value) =>
                                setDraft((prev) => ({
                                    ...prev,
                                    max: value == null ? "" : String(value),
                                }))
                            }
                        />
                        <span className="setting-label step-label">每段</span>
                        <InputNumber
                            aria-label="分段间隔"
                            suffix="USD"
                            stringMode
                            step="100"
                            value={draft.step || null}
                            onChange={(value) =>
                                setDraft((prev) => ({
                                    ...prev,
                                    step: value == null ? "" : String(value),
                                }))
                            }
                        />
                        <Button type="primary" htmlType="submit" aria-label="应用">
                            应用
                        </Button>
                    </form>
                    <p>
                        共 <strong>{buckets.length}</strong> 个价格段{" "}
                        <span>· 最多 60 段</span>
                    </p>
                </div>
                {rangeError && (
                    <p className="form-error" role="alert">
                        {rangeError}
                    </p>
                )}
            </section>
        </ConfigProvider>
    );
}
